import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, Typography, Edges, Backlinks } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarGraph: FC<SidebarComponent> = ({ entity }) => (
  <div style={{ overflow: 'auto' }}>
    <Typography variant="caption">
      <Divider style={{ marginTop: 8, marginBottom: 8 }}>
        Links
      </Divider>
      <Edges sourceId={entity.id} />
      <Divider style={{ marginTop: 8, marginBottom: 8 }}>
        Backlinks
      </Divider>
      <Backlinks id={entity.id} />
    </Typography>
  </div>
)
